"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const bmk_ui_framework_2 = require("@biomemakers/bmk_ui_framework");
const lucide_vue_next_1 = require("lucide-vue-next");
const MixpanelHandler_1 = __importDefault(require("@becrop/components/Modules/Common/Models/MixpanelHandler"));
let SampleCollectingLifeCycleItem = class SampleCollectingLifeCycleItem extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.mixpanelHandler = new MixpanelHandler_1.default();
    }
    mainActionCliked() {
        this.mixpanelHandler.trackEvent('mainActionInProposalStage', {
            'stage': 'sample_collecting',
            'type': 'user',
            'status': this.status
        });
        this.$emit('mainActionCliked', true);
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'pending' })
], SampleCollectingLifeCycleItem.prototype, "status", void 0);
SampleCollectingLifeCycleItem = __decorate([
    (0, vue_property_decorator_1.Options)({
        components: {
            LifeCycleTemplate: bmk_ui_framework_1.LifeCycleTemplate,
            TubeIcon: bmk_ui_framework_2.TubeIcon,
            GitFork: lucide_vue_next_1.GitFork,
            ArrowUpRight: lucide_vue_next_1.ArrowUpRight
        },
    })
], SampleCollectingLifeCycleItem);
exports.default = SampleCollectingLifeCycleItem;
